import { render, staticRenderFns } from "./ShopCatalog.vue?vue&type=template&id=59702d67&scoped=true&"
import script from "./ShopCatalog.vue?vue&type=script&lang=js&"
export * from "./ShopCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ShopCatalog.vue?vue&type=style&index=0&id=59702d67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59702d67",
  null
  
)

export default component.exports